'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (a) {
  return typeof a;
} : function (a) {
  return a && 'function' == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? 'symbol' : typeof a;
};
function _toConsumableArray(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) c[b] = a[b];
    return c;
  }
  return Array.from(a);
}
var _exists = function (a, b) {
    return 0 < a.filter(function (c) {
      return c.id === b;
    }).length;
  },
  _index = function (a, b) {
    return _exists(a, b) && a.indexOf(_find(a, b));
  },
  _find = function (a, b) {
    return _exists(a, b) && a.filter(function (c) {
      return c.id === b;
    })[0];
  },
  _create = function (a, b) {
    return !_exists(a, b.id) && [].concat(_toConsumableArray(a), [b]);
  },
  _update = function (a, b, c) {
    if (_exists(a, b)) {
      var d = [].concat(_toConsumableArray(a)),
        e = _index(d, b);
      return d[e] = Object.assign({}, d[e], c), d;
    }
    return _create(a, c);
  },
  _destroy = function (a, b) {
    return a.filter(function (c) {
      return c.id !== b;
    });
  },
  _merge = function (a, b) {
    var c = 2 < arguments.length && arguments[2] !== void 0 && arguments[2];
    if (!b) return a;
    return a instanceof Array ? _arrayMerge(a, b, 'id', c) : 'object' === ('undefined' == typeof a ? 'undefined' : _typeof(a)) ? _objectMerge(a, b, 'id', c) : void 0;
  },
  _objectMerge = function (a, b) {
    for (var h, c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 'id', d = arguments[3], e = Object.assign({}, a), f = Object.keys(b), g = 0; g < f.length; g++) h = f[g], e[h] = b[h] && 'object' === _typeof(b[h]) && !b[h] instanceof Array && d ? _objectMerge(e[h], b[h], c, d) : b[h] && b[h] instanceof Array ? _arrayMerge(e[h], b[h], c, d) : b[h];
    return e;
  },
  _arrayMerge = function (a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 'id',
      d = arguments[3];
    if (!b) return a;
    var e = [].concat(_toConsumableArray(a));
    return b.forEach(function (f) {
      if (_existsByProp(e, c, f[c])) {
        var g = _findByProp(e, c, f[c]),
          h = _mergeByProp(_findByProp(e, c, f[c]), f, c, d);
        e = _updateByProp(e, c, f[c], h);
      } else e = _createByProp(e, c, f);
    }), e;
  },
  _existsByProp = function (a, b, c) {
    return a && 0 < a.filter(function (d) {
      return d[b] === c;
    }).length;
  },
  _indexByProp = function (a, b, c) {
    return _existsByProp(a, b, c) && a.indexOf(_findByProp(a, b, c));
  },
  _findByProp = function (a, b, c) {
    return _existsByProp(a, b, c) && a.filter(function (d) {
      return d[b] === c;
    })[0];
  },
  _createByProp = function (a, b, c) {
    return !_existsByProp(a, b, c[b]) && [].concat(_toConsumableArray(a), [c]);
  },
  _updateByProp = function (a, b, c, d) {
    if (_existsByProp(a, b, c)) {
      var e = [].concat(_toConsumableArray(a)),
        f = _indexByProp(e, b, c);
      return e[f] = Object.assign({}, e[f], d), e;
    }
    return _createByProp(a, b, d);
  },
  _destroyByProp = function (a, b, c) {
    return a.filter(function (d) {
      return d[b] !== c;
    });
  },
  _mergeByProp = function (a, b, c) {
    var d = 3 < arguments.length && arguments[3] !== void 0 && arguments[3];
    if (!b) return a;
    return a instanceof Array ? _arrayMerge(a, b, c, d) : 'object' === ('undefined' == typeof a ? 'undefined' : _typeof(a)) ? _objectMerge(a, b, c, d) : void 0;
  },
  _promiseDispatch = function (a) {
    return function (b) {
      return new Promise(function (c) {
        b(a), c();
      });
    };
  },
  _whatChanged = function (a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 'Props changed';
    for (var d in console.group(c), b) a[d] !== b[d] && console.log(d, 'old val: ', a[d], ' new val: ', b[d]);
    console.groupEnd();
  };
module.exports = {
  find: _find,
  index: _index,
  create: _create,
  update: _update,
  destroy: _destroy,
  merge: _merge,
  existsByProp: _existsByProp,
  indexByProp: _indexByProp,
  findByProp: _findByProp,
  createByProp: _createByProp,
  updateByProp: _updateByProp,
  destroyByProp: _destroyByProp,
  mergeByProp: _mergeByProp,
  promiseDispatch: _promiseDispatch,
  whatChanged: _whatChanged
};